// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { format } from "date-fns";
// import Loader from "./Loader";

// const TrashTable = () => {
//   const [listData, setListData] = useState([]);
//   const [loader, setLoader] = React.useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5; // Adjust this value as needed

//   useEffect(() => {
//     GetList();
//   }, []);

//   const GetList = async () => {
//     setLoader(true);
//     const token = localStorage.getItem("token");
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };
//     const data = {
//       AwsAccessKey: "AKIATZQNUTWGSDMM45YX",
//       AwsBucket: "dcm-cloud",
//       AwsSecretAccessKey: "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",
//     };
//     try {
//       let response = await axios.post(
//         "https://app.dcmcloud.com/keyImages/v1/updateFolder/getListOfDeleted",
//         data,
//         { headers }
//       );
//       setListData(response?.data?.data.reverse());
//       setLoader(false);
//     } catch (error) {
//       //console.log(error);
//       setLoader(false);
//     }
//   };

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = listData.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(listData.length / itemsPerPage);

//   return (
//     <div>
//       {loader ? (
//         <div className="my-20">
//           <Loader />
//         </div>
//       ) : (
//         <div className="w-10/12 mx-auto relative overflow-x-auto shadow-md sm:rounded-lg">
//           <div className="w-full border p-3 font-semibold text-lg">Archive</div>
//           <table className="w-full text-sm text-left rtl:text-right text-gray-500 mx-auto">
//             <thead className="text-xs text-gray-700 uppercase">
//               <tr>
//                 <th scope="col" className="px-6 py-3">
//                   Folder Name
//                 </th>
//                 <th scope="col" className="px-6 py-3">
//                   Deleted By
//                 </th>
//                 <th scope="col" className="px-6 py-3">
//                   Permanently removed in
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.length !== 0 ? (
//                 currentItems.map((item) => {
//                   let datehere = "";
//                   if (item.deletedAIn) {
//                     let deletedDate = new Date(item.deletedAIn);
//                     let currentDate = new Date();
//                     let remainingDays = Math.ceil((deletedDate - currentDate) / (1000 * 60 * 60 * 24));
//                     datehere = remainingDays;
//                   }
//                   return (
//                     <tr className="bg-white border-b" key={item.folderName}>
//                       <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
//                         {item.folderName}
//                       </th>
//                       <td className="px-6 py-4">{item.deletedBy}</td>
//                       <td className="px-6 py-4">{item.deletedAIn && datehere} days remaining</td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="3" className="w-full flex justify-center items-center">
//                     <div className="text-center">No Data Found</div>
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//           <div className="flex justify-center my-4">
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="px-4 py-2 mx-1 bg-gray-300 text-gray-700 rounded"
//             >
//               Previous
//             </button>
//             {Array.from({ length: totalPages }, (_, index) => (
//               <button
//                 key={index}
//                 onClick={() => handlePageChange(index + 1)}
//                 className={`px-4 py-2 mx-1 ${currentPage === index + 1 ? "bg-purple-800 text-white" : "bg-gray-300 text-gray-700"} rounded`}
//               >
//                 {index + 1}
//               </button>
//             ))}
//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="px-4 py-2 mx-1 bg-gray-300 text-gray-700 rounded"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TrashTable;

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import { format } from "date-fns";
import Loader from "./Loader";
import { keyImages } from "../constants/Constants";
import {
  AWS_Access_Key_Id,
  AWS_Bucket_Name,
  AWS_Secret_Access_Key,
} from "../constants/bucketCostant";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "folderName",
    numeric: false,
    disablePadding: false,
    label: "Folder Name",
  },
  {
    id: "deletedBy",
    numeric: false,
    disablePadding: false,
    label: "Deleted By",
  },
  {
    id: "deletedAIn",
    numeric: false,
    disablePadding: false,
    label: "Permanently removed on",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  onRequestSort: PropTypes.func.isRequired,
};

function EnhancedTableToolbar() {
  return (
    <Toolbar>
      <Typography
        variant="h6"
        id="tableTitle"
        component="div"
        className="FontFamilyGilroy"
        fontWeight={600}
      >
        Archive / Trash
      </Typography>
    </Toolbar>
  );
}

export default function TrashTable() {
  const [listData, setListData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("folderName");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    GetList();
  }, []);

  const GetList = async () => {
    setLoader(true);
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const data = {
      AwsAccessKey: AWS_Access_Key_Id(),
      AwsBucket: AWS_Bucket_Name(),
      AwsSecretAccessKey: AWS_Secret_Access_Key(),
    };
    try {
      let response = await axios.post(
        `${keyImages}/keyImages/v1/updateFolder/getListOfDeleted`,
        data,
        { headers }
      );
      setListData(response?.data?.data.reverse());
      setLoader(false);
    } catch (error) {
      //console.log(error);
      setLoader(false);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const indexOfLastItem = page * rowsPerPage + rowsPerPage;
  const currentItems = stableSort(
    listData,
    getComparator(order, orderBy)
  ).slice(page * rowsPerPage, indexOfLastItem);

  return (
    <>
      {loader ? (
        <div className="my-20">
          <Loader />
        </div>
      ) : (
        <div
          className="container mt-3 mx-auto trash-table"
          style={{ maxWidth: "1432px" }}
        >
          <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar />
              <TableContainer sx={{ height: "66vh" }}>
                <Table
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                >
                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {currentItems.length !== 0 ? (
                      currentItems.map((item, index) => {
                        let datehere = "";
                        if (item.deletedAIn) {
                          let deletedDate = new Date(item.deletedAIn);
                          let currentDate = new Date();
                          let remainingDays = Math.ceil(
                            (deletedDate - currentDate) / (1000 * 60 * 60 * 24)
                          );
                          datehere = remainingDays;
                        }
                        return (
                          <TableRow hover tabIndex={-1} key={item.folderName}>
                            <TableCell component="th" scope="row" color="white">
                              {item.folderName}
                            </TableCell>
                            <TableCell>{item.deletedBy}</TableCell>
                            <TableCell>
                              {/* {item.deletedAIn && datehere} days remaining */}
                              {item.deletedAIn
                                ? format(
                                    new Date(
                                      item.deletedAIn && item.deletedAIn
                                    ),
                                    "dd-MM-yyy"
                                  )
                                : "N/A"}{" "}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No Data Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={listData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Box>
        </div>
      )}
    </>
  );
}
